import React from "react";
import { createStyles, palette, spacing } from "../../../styles/theme";
import { Icon } from "../Icon";
import { getConditionnalStyle } from "../../../utils/themeUtils";
import { Box } from "../Box";
import { SxProps, Typography } from "@mui/material";
import { MaterialSymbolType, MATERIAL_SYMBOL_TYPE } from "../Icon/IconConstant";

const styles = createStyles({
  container: {
    background: palette.white,
    gap: { xs: spacing.wrapperMobile, md: spacing.wrapperDesktop },
    p: { xs: spacing.wrapperMobile, md: spacing.wrapperDesktop },
    border: `1px solid ${palette.grey.lightGrey}`,
    borderRadius: "8px",
  },
  paymentOption: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    p: "16px",
    borderRadius: "8px",
    border: `1px solid ${palette.grey.midGrey}`,
    cursor: "pointer",
  },
  activePaymentOption: {
    margin: "-1px",
    border: `2px solid ${palette.brand.secondary}`,
  },
});

interface Props {
  text: string | React.ReactNode;
  onClick: () => void;
  startIcon?: MaterialSymbolType | React.ReactNode;
  endIcon?: MaterialSymbolType | React.ReactNode;
  sx?: SxProps;
  active?: boolean;
}

const SelectableBox = ({
  onClick,
  startIcon,
  endIcon,
  text,
  sx,
  active,
}: Props) => {
  return (
    <Box
      sx={[
        styles.paymentOption,
        getConditionnalStyle(sx, sx),
        active && styles.activePaymentOption,
      ]}
      onClick={onClick}
    >
      {typeof startIcon === "string" &&
      MATERIAL_SYMBOL_TYPE.includes(startIcon as MaterialSymbolType) ? (
        <Icon
          icon={startIcon as MaterialSymbolType}
          size={24}
          weight={200}
          color={palette.grey.nearBlack}
        />
      ) : (
        startIcon
      )}
      <Typography variant="textSm">{text}</Typography>
      {typeof endIcon === "string" &&
      MATERIAL_SYMBOL_TYPE.includes(endIcon as MaterialSymbolType) ? (
        <Icon
          icon={endIcon as MaterialSymbolType}
          size={24}
          weight={200}
          color={palette.grey.nearBlack}
        />
      ) : (
        endIcon
      )}
    </Box>
  );
};

export default SelectableBox;
